export const categories = [
  {
    id: 'shoes',
    name: 'Обувь',
    nameEn: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
  },
  {
    id: 'hoodies',
    name: 'Худи / Свитера',
    nameEn: 'Hoodies / Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
  },
  {
    id: 'tshirts',
    name: 'Футболки',
    nameEn: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
  },
  {
    id: 'jackets',
    name: 'Куртки',
    nameEn: 'Jackets',
    url: 'https://kaspreadsheet.com/search-914/name/Shoes.html',
  },
  {
    id: 'pants',
    name: 'Брюки / Шорты',
    nameEn: 'Pants / Shorts',
    url: 'https://kaspreadsheet.com/search-915/name/Shoes.html',
  },
  {
    id: 'headwear',
    name: 'Головные уборы',
    nameEn: 'Headwear',
    url: 'https://kaspreadsheet.com/search-916/name/Shoes.html',
  },
  {
    id: 'sets',
    name: 'Комплекты',
    nameEn: 'Sets',
    url: 'https://kaspreadsheet.com/search-917/name/Shoes.html',
  },
  {
    id: 'underwear',
    name: 'Нижнее бельё',
    nameEn: 'Underwear / Underpants',
    url: 'https://kaspreadsheet.com/search-918/name/Shoes.html',
  },
  {
    id: 'jersey',
    name: 'Джерси',
    nameEn: 'Jersey',
    url: 'https://kaspreadsheet.com/search-919/name/Shoes.html',
  },
  {
    id: 'accessories',
    name: 'Аксессуары',
    nameEn: 'Accessories',
    url: 'https://kaspreadsheet.com/search-920/name/Shoes.html',
  },
  {
    id: 'bags',
    name: 'Сумки',
    nameEn: 'Bags',
    url: 'https://kaspreadsheet.com/search-921/name/Shoes.html',
  },
  {
    id: 'belts',
    name: 'Ремни',
    nameEn: 'Belts',
    url: 'https://kaspreadsheet.com/search-922/name/Shoes.html',
  },
  {
    id: 'perfumes',
    name: 'Парфюмерия',
    nameEn: 'Perfumes',
    url: 'https://kaspreadsheet.com/search-923/name/Shoes.html',
  },
  {
    id: 'other',
    name: 'Прочее',
    nameEn: 'Other Stuff',
    url: 'https://kaspreadsheet.com/search-924/name/Shoes.html',
  },
];